import React from 'react';

interface ContactAdminPageProps {
  /** Optional module label for the message. Defaults to "Data Studio". */
  moduleLabel?: string;
}

/**
 * Phase 1 RBAC v2 gate page for v2 Standard Users without `data_studio`
 * assigned. Plain inline styles to avoid pulling in any UI library at this
 * level \u2014 mirrors the simplicity of `ModelNotFoundPage`.
 */
export default class ContactAdminPage extends React.Component<ContactAdminPageProps> {
  render() {
    const moduleLabel = this.props.moduleLabel || 'Data Studio';
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '32px',
          background: 'var(--app-warm)',
        }}
      >
        <div
          style={{
            maxWidth: 480,
            background: 'white',
            borderRadius: 8,
            border: '1px solid var(--app-line)',
            padding: '32px',
            textAlign: 'center',
          }}
        >
          <h2 style={{ margin: 0, marginBottom: 12 }}>
            You don&apos;t have access to {moduleLabel}
          </h2>
          <p style={{ color: 'var(--app-muted)', margin: 0 }}>
            Your account isn&apos;t assigned to this module. Contact your Org
            Admin to request access.
          </p>
        </div>
      </div>
    );
  }
}
